import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [headerHidden, setHeaderHidden] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  const location = useLocation(); // React Router hook to get current path

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop > lastScrollTop && scrollTop > 100) {
        setHeaderHidden(true);
      } else {
        setHeaderHidden(false);
      }
      setLastScrollTop(scrollTop);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollTop]);

  return (
    <header className={headerHidden ? 'hidden' : ''}>
      <div className="container">
        <div className="header-top">
          <div className="contact-info">
            <span><i className="fas fa-phone"></i> +265 111 775 433, +265 998 955 221</span>
            <span><i className="fas fa-envelope"></i> info@madisonmw.com</span>
            <span><i className="fas fa-map-marker-alt"></i> ADL House, P.O. Box 31507, Lilongwe</span>
          </div>
          <div className="social-links">
            <a href="https://www.facebook.com/profile.php?id=100046424636364"><i className="fab fa-facebook-f"></i></a>
            <a href="https://www.linkedin.com/company/madison-holdings-limited"><i className="fab fa-linkedin"></i></a>
            {/* <a href="#"><i className="fab fa-instagram"></i></a> */}
          </div>
        </div>

        <div className="nav-container">
          <div className="logo" style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
            <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
              <img src="/images/logos/logo2.png" alt="Riverton Dairy" style={{ height: '48px' }} />
              <div className="logo-text" style={{ fontWeight: 700, fontSize: '18px', lineHeight: 1, color: '#ffffffff' }}>
                RIVERTON <span style={{ fontWeight: 400 }}>DAIRY</span>
              </div>
            </Link>
          </div>

          <ul className={`nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
            <li>
              <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
                HOME
              </Link>
            </li>
            <li>
              <Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>
                ABOUT US
              </Link>
            </li>
            <li>
              <Link to="/products" className={location.pathname === '/products' ? 'active' : ''}>
                PRODUCTS
              </Link>
            </li>
            <li>
              <Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>
                CONTACT
              </Link>
            </li>
          </ul>

          <button
            className="cta-btn"
            onClick={() => window.location.href = 'tel:+265998955221'}
          >
            ORDER NOW
          </button>

          <div
            className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
